import momentJalaali from "moment-jalali";
import { faBroom, faToggleOn } from "@fortawesome/free-solid-svg-icons";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ModalProducts from "../../Components/Modals/ModalProducts";
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import { useEffect, useRef, useState } from "react";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { exportToExcel, keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import { getSwappedSerialsReport } from "../store/api/Services";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import DatePicker from "react-datepicker2";
import { EyeFill, EyeSlashFill, FileExcel, List, Printer, Search } from "react-bootstrap-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function SwappedSerialsReport() {
    const dispatch = useDispatch();
    const history = useHistory();
    const frmFilters = useRef();
    const { handleSubmit, register } = useForm();
    const [pending, setPending] = useState(false);
    const [localFilters, setLocalFilters] = useState({});
    const [popProduct, setPopProduct] = useState({ show: false });
    const [popCustomer, setPopCustomer] = useState({ show: false });
    const [showFilter, setShowFilter] = useState(true);
    const settingNames = ['ProductGrouppingType', "ProductDefaultSalePrice", "ProductDefaultSalePriceLabel"];
    const { filterData, settings } = useSelector(state => { return { filterData: state.service.swappedSerialsReportFilters, settings: state.SystemSettingsReducer.systemSettings } });
    const pgType = Array.isArray(settings ?? "") && settings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(settings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const pDefaultSalePrice = Array.isArray(settings) ? settings.find(s => s.SettingName === "ProductDefaultSalePrice")?.SettingValue : "";
    const pDefaultSalePriceLabel = Array.isArray(settings) ? settings.find(s => s.SettingName === "ProductDefaultSalePriceLabel")?.SettingValue : "";
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف" },
        { colName: "ProductHolder", colTitle: "مارک محصول" },
        { colName: "ProductName", colTitle: "نام محصول" },
        { colName: "ProductModel", colTitle: "مدل محصول" },
        { colName: "ProductSerial", colTitle: "سریال محصول" },
        { colName: "NewProductHolder", colTitle: "مارک محصول جایگزین" },
        { colName: "NewProductName", colTitle: "نام محصول جایگزین" },
        { colName: "NewProductModel", colTitle: "مدل محصول جایگزین" },
        { colName: "NewProductSerial", colTitle: "سریال محصول جایگزین" },
        { colName: "CustomerName", colTitle: "نام مشتری" },
        { colName: "InvoiceNumber", colTitle: "شماره سرویس" },
        { colName: "PSwapDate", colTitle: "تاریخ جایگزینی" },
        { colName: "PSendDeliverDate", colTitle: "تاریخ تحویل/ارسال" },
        { colName: "AmountCustomerShouldPay", colTitle: "جمع خدمات", colType: "currency" },
        { colName: "SwapPriceDifference", colTitle: "اختلاف هزینه", colType: "currency"},
        {colName:"CustomerInDebtForSwap", colTitle:"بدهکار تعویض", colType:"boolean"}
    ]
    function showModalProduct(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data) {
                setLocalFilters({ ...localFilters, ...data })
            }
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData });
    }
    function search(data) {
        const dateFrom = document.getElementsByName("DateFrom")[0].value;
        if (dateFrom !== "") {
            data.SenDateFrom = localFilters.DateFrom;
            data.PDateFrom = dateFrom;
        }
        const dateTo = document.getElementsByName("DateTo")[0].value;
        if (dateTo !== "") {
            data.SendDateTo = localFilters.DateTo;
            data.PDateTo = dateTo;
        }
        const sDateFrom = document.getElementsByName("SwapDateFrom")[0].value;
        if (sDateFrom !== "") {
            data.SwapDateFrom = localFilters.SwapDateFrom;
            data.PSwapDateFrom = sDateFrom;
        }
        const sDateTo = document.getElementsByName("SwapDateTo")[0].value;
        if (sDateTo !== "") {
            data.SwapDateTo = localFilters.SwapDateTo;
            data.PSwapDateTo = sDateTo;
        }
        data.Skip = 0;
        dispatch(getSwappedSerialsReport(data));

    }
    function showModalCustomer(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectCustomer = (data) => {
            //if (data) {
            setLocalFilters({
                ...localFilters,
                CustomerID: data?.ID,
                CustomerName: data?.Name
            })
            //}
        }
        setPopCustomer({ show: true, value: e.key, invoiceCustomers: false, justForSelect: true, setCustomerData: onSelectCustomer });
    }
    function toExcel() {
        const url = `api/ServiceReportsAPI/GetSwappedSerialsReport`;
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        setPending(true);
        exportToExcel("SwapSerialsReport", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/SwappedSerialsReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/GetSwappedSerialsReport`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function clearFilters() {
        frmFilters.current.reset();
        setLocalFilters({});
        dispatch(getSwappedSerialsReport({ Take: 10, Skip: 0 }));
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function showService(row) {
        history.push(`/Services/Service/${row.ID}/repair`, null);
    }
    useEffect(() => {
        dispatch(getSystemSettings(settingNames));
        document.body.classList = "notMain";
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} defaultSalePrice={pDefaultSalePrice}
                    defaultSalePriceLabel={pDefaultSalePriceLabel} hideNewProduct={true} />
                <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} />
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faToggleOn} size="lg" />&nbsp;
                    گزارش دستگاههای تعویض شده
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder" >
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>تاریخ تحویل از: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="DateFrom" value={localFilters?.SendDateFrom ? momentJalaali(localFilters.SendDateFrom) : null}
                                    onChange={val => setLocalFilters({ ...localFilters, SendDateFrom: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ تحویل تا: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="DateTo" value={localFilters?.SendDateTo ? momentJalaali(localFilters.SendDateTo) : null}
                                    onChange={val => setLocalFilters({ ...localFilters, SendDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ جایگزینی از: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="SwapDateFrom" value={localFilters?.SwapDateFrom ? momentJalaali(localFilters.SendDateFrom) : null}
                                    onChange={val => setLocalFilters({ ...localFilters, SwapDateFrom: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ جایگزینی تا: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="SwapDateTo" value={localFilters?.SwapDateTo ? momentJalaali(localFilters.SwapDateTo) : null}
                                    onChange={val => setLocalFilters({ ...localFilters, SwapDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مشخصات مشتری: </label>
                                <input type="hidden" name="CustomerID" ref={register({})} value={localFilters?.CustomerID ?? filterData?.CustomerID ?? ""} />
                                <Form.Control name="CustomerName" ref={register({})} value={localFilters?.CustomerName ?? filterData?.CustomerName ?? ""} readOnly />
                                <Button className="btn-input-tiny" onClick={showModalCustomer} style={{ top: 25 }}><List size={23} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره سریال محصول:</label>
                                <Form.Control name="SerialNumber" ref={register({})} defaultValue={filterData?.ProductSerial ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره سریال محصول جایگزین:</label>
                                <Form.Control name="NewProductSerial" ref={register({})} defaultValue={filterData?.NewProductSerial ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه:</label>
                                <Form.Control as="select" name="Take" ref={register({})} defaultValue={filterData?.Take ?? 10} >
                                    <option value={0}>تمام ردیفها</option>
                                    <option value={5}>5 ردیف</option>
                                    <option value={10}>10 ردیف</option>
                                    <option value={20}>20 ردیف</option>
                                    <option value={50}>50 ردیف</option>
                                    <option value={1000}>100 ردیف</option>
                                </Form.Control>
                            </Col>
                            {/* {
                                pgType === 1 ?
                                    <Col md={2} className="form-group">
                                        <label>نام محصول:</label>
                                        <Form.Control name="ProductName" ref={register({})} />
                                    </Col> :
                                    <Fragment>
                                        <Col md={2} className="form-group">
                                            <label>مارک محصول:</label>
                                            <select className="form-control" name="ProductHolder" ref={register({})} defaultValue={filterData?.HolderName ?? ""}>
                                                <option value="">انتخاب کنید</option>
                                                {Array.isArray(holders) && holders.map((item, i) => <option value={item.HolderName} key={i}>{item.HolderName}</option>)}
                                            </select>
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>نوع محصول:</label>
                                            {productTypes === "PENDING" ?
                                                <div className="form-control" style={{ textAlign: "center" }}>
                                                    <Loader type="BallTriangle" color="#bb1370" height={25} width={25} />
                                                </div> :
                                                <select className="form-control" name="ProductType" ref={register({})} defaultValue={filterData?.ProductType ?? ""}>
                                                    <option value="">انتخاب کنید</option>
                                                    {Array.isArray(productTypes) && productTypes.map((item, i) => <option value={item.Name} key={i}>{item.Name}</option>)}
                                                </select>
                                            }
                                        </Col>
                                    </Fragment>
                            }
                            <Col md={2} className="form-group">
                                <label>مدل محصول:</label>
                                <Form.Control name="ProductModel" ref={register({})} defaultValue={filterData?.ProductModel ?? ""} />
                            </Col>
                            {
                                pgType === 1 ?
                                    <Col md={2} className="form-group">
                                        <label>نام محصول جایگزین:</label>
                                        <Form.Control name="NewProductName" ref={register({})} />
                                    </Col> :
                                    <Fragment>
                                        <Col md={2} className="form-group">
                                            <label>مارک محصول جایگزین:</label>
                                            <select className="form-control" name="NewProductHolder" ref={register({})} defaultValue={filterData?.HolderName ?? ""}>
                                                <option value="">انتخاب کنید</option>
                                                {Array.isArray(holders) && holders.map((item, i) => <option value={item.HolderName} key={i}>{item.HolderName}</option>)}
                                            </select>
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>نوع محصول جایگزین:</label>
                                            {productTypes === "PENDING" ?
                                                <div className="form-control" style={{ textAlign: "center" }}>
                                                    <Loader type="BallTriangle" color="#bb1370" height={25} width={25} />
                                                </div> :
                                                <select className="form-control" name="NewProductType" ref={register({})} defaultValue={filterData?.ProductType ?? ""}>
                                                    <option value="">انتخاب کنید</option>
                                                    {Array.isArray(productTypes) && productTypes.map((item, i) => <option value={item.Name} key={i}>{item.Name}</option>)}
                                                </select>
                                            }
                                        </Col>
                                    </Fragment> 
                            }
                            <Col md={2} className="form-group">
                                <label>مدل محصول جایگزین:</label>
                                <Form.Control name="NewProductModel" ref={register({})} defaultValue={filterData?.NewProductModel ?? ""} />
                            </Col>*/}
                        </Row>
                        <div className="mt-1">
                            <Button className="group-Btn-large" type="submit"><Search size={18} /> جستجوی نتایج</Button>
                            <Button className="group-Btn-large" variant="secondary" onClick={printReport}><Printer size={18} /> چاپ نتایج</Button>
                            <Button className="group-Btn-large" variant="info" onClick={toExcel} disabled={pending}><FileExcel size={18} /> ارسال به اکسل</Button>
                        </div>
                    </form>
                    <BihamtaTable columns={tableCols} reducerName="service" objectName="swappedSerialsReportData" rowClick={showService}
                        searchMethod={(data) => dispatch(getSwappedSerialsReport(data))} filterData={filterData} style={{ whiteSpace: "nowrap" }} hasPaging />
                </Card.Body>
            </Card>
        </div>
    )
}
